var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Group.2eb3a299.png","uri@2x": __webpack_public_path__ + "static/media/Group.d2434589.png","uri@3x": __webpack_public_path__ + "static/media/Group.09b33c33.png",
    width: 5,
    height: 6
});